import { CanActivate, Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { SessionService } from "../core/core/session.service";
import { PermissionsService } from "../core/services/permissions/permissions.service";
import { RoutingHistoryService } from "../core/services/routing-history/routing-history.service";

@Injectable()
export class ShellGuard implements CanActivate {
  constructor (
    private sessionService: SessionService,
    private permissionService: PermissionsService,
    private router: Router,
    private routingHistry: RoutingHistoryService
  ) {
  }

  public canActivate(next, state) {
    return this.sessionService.isSessionActive().map(sessionActive => {
      if(!sessionActive) {
          this.router.navigate(['/login']);
          return false;
      }
      else {
        let canShowPermission =  this.checkPermissionsToShow(next.data.claimType);
        if(!canShowPermission){
          this.router.navigate(['dashboard']);
        }
        return canShowPermission;
      }
    });
  }

  checkPermissionsToShow(showClaimInternalname: string): boolean{ 
    if(showClaimInternalname){
      let permissions =  this.permissionService.getUserPermissions(showClaimInternalname);
      let path = this.routingHistry.getCurrentUrl();
      if(!permissions.canShow && !permissions[showClaimInternalname] && !path.includes('login')) { 
        sweetAlert('Brak uprawnień do podglądu');
      }
      return permissions.canShow || permissions[showClaimInternalname];
    }
    return true;
  }

}
